const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;

const IsEmail = (email) => EMAIL_REGEX.test(email);
export default IsEmail;
